<template>
    <md-dialog :md-active.sync="showDialogGrupo" :md-click-outside-to-close="false">
        <md-dialog-title class="text-center">
            {{ labels.createGroup }}
        </md-dialog-title>
        <md-dialog-content>
            <b-row class="">
                <b-col cols="2"></b-col>
                <b-col cols="4" class="text-left">
                    <h5>{{labels.name}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <md-field>
                        <md-input
                            type="text"
                            name="name"
                            v-model="nuevoGrupo.nombre"
                            :placeholder="labels.name"                                
                        />
                    </md-field>
                </b-col>
            </b-row>

            <md-dialog-actions class="mt-3">
                <md-button class="md-primary" @click="crearGrupo">{{ labels.save }}</md-button>
                <md-button class="md-accent" @click="clicked">{{ labels.close }}</md-button>
            </md-dialog-actions>
        </md-dialog-content>
    </md-dialog>
</template>

<script>
    import Grupo from '@/services/Grupo'

    export default {
        name : "NewGrupo",
        props: ['showDialogGrupo'],

        data: () => ({
            nuevoGrupo: {
                nombre: ""
            }
        }),

        computed: {
            labels(){
                if (this.$store.state._language == "es-ES") {
                    return {
                        createGroup: "Crear Grupo",
                        name: "Nombre",
                        save: "Guardar",
                        close: "Cerrar"
                    }
                }else{
                    return {
                        createGroup: "Create Group",
                        name: "Name",
                        save: "Save",
                        close: "Close"
                    }
                }
            }
        },

        methods: {
            crearGrupo(){
                Grupo.create(this.nuevoGrupo)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.nuevoGrupo = { nombre: "" };
                    this.$emit('clicked', false);
                    this.$emit('grupoCreado');
                }).catch((error) => {
                    console.log(error)
                    this.$toast.error('Error al crear el grupo');
                })
            },
            clicked(){
                this.nuevoGrupo = { nombre: "" };
                this.$emit('clicked', false);
            }
        }
    }
</script>